<div class="layout-header-container">
  <div class="layout-header {{ headerBackground }}">
    <div class="header-title-container">
      <app-chevron-left-icon
        class="clickable"
        height="24px"
        width="24px"
        color="var(--gray-600)"
        (click)="goBack()"
        *ngIf="showBackButton"
      />
      <div class="header-title">
        <ng-content select="[title]" />
      </div>
    </div>
    <div class="header-actions">
      <ng-content select="[actions]" />
    </div>
  </div>
  <div class="header-navigation-container">
    <app-tab-navigation
      [navigationItems]="navigationItems"
      *ngIf="navigationItems && !overrideNavigation"
    />
    <ng-content select="[navigation]" *ngIf="overrideNavigation" />
  </div>
</div>
<div class="layout-container">
  <ng-content />
</div>
